import { enAccount } from '../en';
import { frAccount } from '../fr';
import { esAccount } from '../es';
import { deAccount } from '../de';

export const accountModuleTranslations = {
  en: enAccount,
  fr: frAccount,
  es: esAccount,
  de: deAccount,
} as const;

